import {memo} from 'react';

import type {SVGProps} from 'react';

export const CheckIcon = memo(function CheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M23.3332 38.7503C31.8476 38.7503 38.7498 31.848 38.7498 23.3337C38.7498 14.8193 31.8476 7.91699 23.3332 7.91699C14.8188 7.91699 7.9165 14.8193 7.9165 23.3337C7.9165 31.848 14.8188 38.7503 23.3332 38.7503Z"
          fill="var(--icon-fill-green)"
        />
        <path
          d="M29.4998 32.333C26.8332 34.333 23.5832 35.583 19.9998 35.583C11.4165 35.583 4.4165 28.583 4.4165 19.9997C4.4165 17.833 4.9165 15.6663 5.6665 13.833"
          stroke="var(--icon-stroke-green)"
          strokeWidth={2.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.0835 8.00033C12.7502 5.83366 16.2502 4.41699 20.0002 4.41699C28.5835 4.41699 35.5835 11.417 35.5835 20.0003C35.5835 21.917 35.2502 23.7503 34.5835 25.5003"
          stroke="var(--icon-stroke-green)"
          strokeWidth={2.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.75 19.5833L17.9167 23.75L26.6667 15"
          stroke="var(--icon-stroke-green)"
          strokeWidth={2.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
});
